module.exports = __webpack_public_path__ + "img/body-3-lg.5cac583d.png";